import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  all: unset;
  margin: 10px;
  background-color: ${({ variant }) =>
    variant === "primary" ? "#18316e" : "#fff"};
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};
  height: 40px;
  gap: 5px;
  padding: 10px;
  width: ${({ isMobile, width, alwaysOpen }) =>
    alwaysOpen || isMobile ? `${width + 50}px` : "40px"};
  border-radius: 25px;
  border: ${({ variant }) =>
    variant === "primary" ? "none" : "1px solid #18316e"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ variant }) => (variant === "primary" ? "#fff" : "#18316e")};
  transition: all 0.45s ease-in-out;
  overflow: hidden;
  font-size: 15px;
  text-align: ${({ isMobile }) => (isMobile ? "center" : "left")};

  ${({ isMobile, width, alwaysOpen, variant }) =>
    !isMobile &&
    !alwaysOpen &&
    `
    &:hover {
      background-color: ${variant === "primary" ? "#1976d2" : "#e8e8e8"};
      padding-left: 0;
      padding: 10px;
      width: ${width + 50}px;
    }

    &:hover p {
      width: ${width}px;
    }
  `}

  ${({ alwaysOpen, variant }) =>
    alwaysOpen &&
    `
    &:hover {
      background-color: ${variant === "primary" ? "#1976d2" : "#e8e8e8"};
    }
  `}

  p {
    width: ${({ isMobile, width, alwaysOpen }) =>
      alwaysOpen || isMobile ? `${width}px` : "0"};
    transition: all 0.45s ease-in-out;
    white-space: nowrap;
    overflow: hidden;
    transform-origin: right;
    padding: ${({ isMobile, alwaysOpen }) =>
      alwaysOpen || isMobile ? "0 4px" : "0"};
  }
`;

const BtnGenericHeader = ({
  icon,
  label,
  alwaysOpen = false,
  variant = "default",
  disabled = false,
  ...rest
}) => {
  const [tamanhoWidth, setTamanhoWidth] = useState(0);
  const isMobile = useMediaQuery("(max-width: 1405px)");

  useEffect(() => {
    const calculaTamanhoLabel = () => {
      const quantCaracteres = label.length;

      const width = quantCaracteres * 10;

      setTamanhoWidth(width);
    };

    calculaTamanhoLabel();
  }, [label]);

  const styleDivContainer = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <>
      <div style={styleDivContainer}>
        <StyledButton
          width={tamanhoWidth}
          isMobile={isMobile}
          alwaysOpen={alwaysOpen}
          variant={variant}
          disabled={disabled}
          {...rest}
        >
          {icon}
          <p>{label}</p>
        </StyledButton>
      </div>
    </>
  );
};
export default BtnGenericHeader;
